import { Navigate, useLocation } from "react-router-dom";
import { authAPI } from "../../services/api";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated = authAPI.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const currentUser = authAPI.getCurrentUser();
  const isEmployee = currentUser?.role === "Employee";
  const permissions = currentUser?.permissions;

  // Employees can only access home, dashboard, report, bill, settings
  if (isEmployee) {
    const allowedBasePaths = ["/", "/dashboard", "/report", "/bill", "/settings"];
    const currentPath = location.pathname;
    const isAllowed = allowedBasePaths.some(p =>
      p === "/" ? currentPath === "/" : currentPath.startsWith(p)
    );
    if (!isAllowed) {
      return <Navigate to="/" replace />;
    }
  }

  // Enforce module-level permissions if they are set
  if (permissions && permissions.length > 0) {
    const currentPath = location.pathname;
    const pathToCode = {
      "/": "HOME",
      "/dashboard": "DASHBOARD",
      "/report": "REPORT.REPORT",
      "/bill": "REPORT.BILL",
    };

    if (!currentPath.startsWith("/settings")) {
      const requiredCode = pathToCode[currentPath];
      if (requiredCode && !permissions.includes(requiredCode)) {
        return <Navigate to="/" replace />;
      }
    }
  }

  return children;
}

export default ProtectedRoute;
